export default "__VITE_ASSET__58a19b0e__"